// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nl-0";